import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useMarkAsShippedCarriers } from '../../../hooks/carrier';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import GetCarrierDisplayName from '../../../../../components/data-driven-logo/get-carrier-display-name';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_CARRIER_ID } from '../../../constants';

import style from '../../style.module.less';

const Carrier = () => {
  const intl = useIntl();
  const { bulkUpdateFulfillmentPlans } = useContext(MarkAsShippedContext);

  const carriers = useMarkAsShippedCarriers();

  return (
    <div onScroll={(e) => e.stopPropagation()}>
      <DropdownMenu className={style['bulk-update-item']}>
        <DropdownMenuToggler>
          <FormattedMessage defaultMessage='Carrier' description='markAsShippedmodal.button.carrier' id='Stecuu' />
        </DropdownMenuToggler>
        {carriers.map((carrier) => {
          const carrierNameMessage = GetCarrierDisplayName(carrier.carrierId);
          return (
            <DropdownMenuItem
              key={carrier.carrierId}
              onClick={() => bulkUpdateFulfillmentPlans(MARK_AS_SHIPPED_CARRIER_ID, carrier.carrierId)}
            >
              {intl.formatMessage(carrierNameMessage, carrierNameMessage.values)}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

export default Carrier;
